import { api } from './client';

export interface ImportJobState {
  job_id:     string;
  status:     'running' | 'succeeded' | 'failed';
  dbname:     string;
  started_at: string;
  error?:     string;
}

export interface StartImportResult {
  job_id:            string;
  websocket_channel: string;
}

export function startImport(
  dbname: string,
  file: File,
  charset: string,
  collation: string,
): Promise<StartImportResult> {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('confirm_name', dbname);
  fd.append('charset', charset);
  fd.append('collation', collation);
  return api.post<StartImportResult>(
    `/mysql/databases/${encodeURIComponent(dbname)}/import`,
    fd,
    // No Content-Type header — browser sets multipart boundary automatically
  ).then((r) => r.data);
}

export function getImportJob(jobId: string): Promise<ImportJobState> {
  return api.get<ImportJobState>(`/mysql/import-jobs/${jobId}`).then((r) => r.data);
}
